import { products } from '../product'
import { describeTable } from './describeTable'

describeTable(products, {
  description: `The catalogue that visit_line_items are picked from: materials (parts, filters, chimney components) and labour items. Most material rows come from a wholesaler price-list import (OVT file, supplier e.g. Onninen): list price minus the discount-group percentage gives the purchase price, and purchase price * 1.20 gives the default selling price. Staff-created rows (labour, custom items) fill the same columns by hand.
All prices are NET (alv 0). This table is a price list, not a transaction log — nothing here says what was sold; join visit_line_items.product_id for that. Unique per (supplier, product_number, supplier_code).`,
  columns: {
    type: 'material = physical goods, labor = work items and surcharges.',
    supplier: 'Wholesaler name for imported rows; NULL for in-house items.',
    supplierCode: "Supplier's quick code (pikakoodi), e.g. 'CML507'.",
    productNumber: "Supplier's article number.",
    unit: "Sales unit as the supplier states it, e.g. 'KPL', 'M'.",
    discountGroup:
      "Supplier discount-group code (e.g. 'AU6') that set the purchase price at import.",
    internalSupplierListPriceVat0:
      'Supplier list price, net, before the discount group.',
    internalPurchasePriceVat0:
      'What the company pays per unit, net. Cost basis for margin.',
    unitPriceVat0:
      'Default selling price per unit, net (purchase price + default_markup_percent). Copied into visit_line_items.unit_price_vat0 when a line is added.',
    defaultMarkupPercent:
      'Markup applied over the purchase price, 20 by default.',
    salesIncludedItems:
      'JSON array of strings: what the sales offer says is included. Snapshotted into offers.',
    salesPrerequisites:
      'JSON array of strings: preconditions the customer must meet. Snapshotted into offers.',
    salesExclusions:
      'JSON array of strings: what is explicitly not included. Snapshotted into offers.',
  },
})
